import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { loadUser, updateUser, clearUser } from '../../actions/user'
import { notificate } from '../../actions/notification'
import { UserForm, Spinner } from '../'
import { userValidator } from '../../validators'
import { links } from '../../utils'

class UserEdit extends Component {
  state = {
    errors: {}
  };

  componentDidMount () {
    this._loadData()
  };

  componentDidUpdate () {
    const { redirect } = this.props.user
    if (redirect) {
      return this.props.history.push(redirect)
    }
  };

  render () {
    const { errors } = this.state
    const { sending } = this.props.user
    const user = this.props.user.edit_user
    const hasUser = user && user.id

    return (
      <div className="main-content">
        <header className="main-content__header">
          <h1 className="main-content__title">Adicionar user</h1>
          <Link to={links.get('users')} className="main-content__cancel">Voltar</Link>
        </header>
        {sending && !hasUser &&
          <div className="spinner-box">
            <Spinner />
          </div>
        }
        {hasUser &&
          <UserForm
            sending={sending}
            editUser={user}
            errors={errors}
            onSubmit={this._handleSubmit}
          />
        }
      </div>
    )
  };

  _loadData = () => {
    const { token } = this.props
    const id = this.props.history.location.pathname.split('/').pop()
    this.props.clearUser()
    this.props.loadUser(id, token)
  };

  _handleSubmit = data => {
    const errors = {}
    this.setState({ errors }, () => {
      userValidator.update(data).then(result => {
        if (result.success) {
          const { token } = this.props
          this.props.updateUser(data, token)
        } else {
          this.setState({ errors: result.errors })
        }
      }).catch(error => {
        this.props.notificate(error.message)
      })
    })
  };
}

const mapStateToProps = (state) => {
  return {
    token: state.user.user.token,
    user: state.user
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadUser: (id, token) => dispatch(loadUser(id, token)),
    updateUser: (data, token) => dispatch(updateUser(data, token)),
    clearUser: () => dispatch(clearUser()),
    notificate: message => dispatch(notificate(message))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserEdit)
